import React, { useEffect, useRef } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, deleteEntity } from './tire-manufacturer.reducer';

export const TireManufacturerDeleteDialog = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const hasDeleted = useRef(false);

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const tireManufacturerEntity = useAppSelector(state => state.tireManufacturer.entity);
  const updateSuccess = useAppSelector(state => state.tireManufacturer.updateSuccess);

  const handleClose = () => {
    props.history.push('/tire-manufacturer' + props.location.search);
  };

  useEffect(() => {
    if (updateSuccess && hasDeleted.current) {
      handleClose();
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    hasDeleted.current = true;
    dispatch(deleteEntity(tireManufacturerEntity.id));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="tireManufacturerDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="fleetSenseApp.tireManufacturer.delete.question">
        <Translate contentKey="fleetSenseApp.tireManufacturer.delete.question" interpolate={{ id: tireManufacturerEntity.name }}>
          Are you sure you want to delete this TireManufacturer?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="app-confirm-delete-tireManufacturer" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Delete</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TireManufacturerDeleteDialog;
